import { makeAutoObservable } from 'mobx'
import * as moment from 'moment'
import { clone } from 'lodash'
import { ISO_DATE_FORMAT, WORK_STATUS } from '../utils/constants'
import { WorkRequest } from '../requests/WorkRequest'
import { UserGroupRequest } from '../requests/UserGroupRequest'

class WorkStore {
  workList = []
  subwork = []
  incompleteWorkList = []
  permission = undefined
  totalWork = 0
  workDetail = {}
  groupVanThu = null
  commentWorkList = undefined
  workPendingCount = 0
  workCompleteCount = 0

  defaultQueryParams = {
    page: 0,
    size: 10,
    title: null,
    from_date: null,
    to_date: null,
    status: undefined,
    work_type: null,
    permission: undefined,
    parent_id: null,
    is_important: null,
    is_unread: null,
    assignee: null,
  }
  constructor() {
    makeAutoObservable(this)
  }

  queryParams = clone(this.defaultQueryParams)

  setIsReadTask = payload => {
    if (!payload.parent_code) {
      return (this.workList = this.workList.map(el =>
        el.code === payload.code ? { ...el, is_read: true } : el
      ))
    }
    this.workList = this.workList.map(el =>
      el.code !== payload.parent_code
        ? el
        : {
            ...el,
            subwork: el.subwork.map(item =>
              item.code !== payload.code
                ? item
                : {
                    ...item,
                    is_read: true,
                  }
            ),
          }
    )
  }

  workTypeList = [
    {
      id: 'INTERNAL',
      name: 'Nội bộ trong Ban',
    },
    {
      id: 'CONSULT',
      name: 'Xin ý kiến các Ban',
    },
    {
      id: 'DOCUMENT',
      name: 'Từ văn bản',
    },
    {
      id: 'ELECTRONIC',
      name: 'Trình ký văn bản',
    },
    {
      id: 'DEPLOY',
      name: 'Từ nhiệm vụ',
    },
    {
      id: 'POLICY',
      name: 'Xin chủ trương',
    },
    {
      id: 'OTHER',
      name: 'Khác',
    },
  ]

  workTypeListForSearch = [
    {
      id: 'INTERNAL,CONSULT,POLICY,OTHER,ELECTRONIC',
      name: 'Công việc chung',
    },
    {
      id: 'INTERNAL',
      name: 'Nội bộ trong Ban',
    },
    {
      id: 'CONSULT',
      name: 'Xin ý kiến các Ban',
    },
    {
      id: 'ELECTRONIC',
      name: 'Trình ký văn bản',
    },
    {
      id: 'POLICY',
      name: 'Xin chủ trương',
    },
    {
      id: 'OTHER',
      name: 'Khác',
    },
  ]

  clearQueryParams = () => {
    this.queryParams = clone(this.defaultQueryParams)
  }

  setQueryParams = payload => {
    this.defaultQueryParams = payload
  }

  getWorkList = params => {
    return new Promise((resolve, reject) => {
      WorkRequest.getWorkList(params)
        .then(response => {
          if (!response) {
            return resolve(null)
          }
          resolve(response.data)
          this.workList = [...this.workList, ...response.data.data]
          this.totalWork = response.data.total_count
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getIncompleteWorkList = () => {
    return new Promise((resolve, reject) => {
      WorkRequest.getWorkList(this.queryParams)
        .then(response => {
          this.incompleteWorkList = response.data.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  markImportantWork = (work_code, isImportant) => {
    return new Promise((resolve, reject) => {
      WorkRequest.markImportantWork(work_code, isImportant)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  /** Create user */
  createWork = data => {
    return new Promise((resolve, reject) => {
      WorkRequest.createWork(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      ;(rv[x[key]] = rv[x[key]] || []).push(x)
      return rv
    }, {})
  }

  uniqBy(a, key) {
    let seen = new Set()
    return a.filter(item => {
      let k = key(item)
      return seen.has(k) ? false : seen.add(k)
    })
  }

  // Click collapse get list subwork
  getListSubWork = work_code => {
    return new Promise((resolve, reject) => {
      WorkRequest.getWorkDetail(work_code)
        .then(response => {
          this.subwork = [...this.subwork, ...response.data?.subwork]
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getWorkDetail = work_code => {
    return new Promise((resolve, reject) => {
      WorkRequest.getWorkDetail(work_code)
        .then(response => {
          let workDetailData = response.data
          if (
            response.data.code !== work_code &&
            response.data.subwork.length > 0
          ) {
            workDetailData = response.data.subwork[0]
          }
          const complete_date = moment(workDetailData.complete_date).format(
            ISO_DATE_FORMAT
          )
          const due_date = moment(workDetailData.due_date).format(
            ISO_DATE_FORMAT
          )
          if (
            workDetailData.due_date &&
            workDetailData.status === WORK_STATUS.COMPLETE &&
            moment(complete_date).isAfter(due_date)
          ) {
            workDetailData = {
              ...workDetailData,
              overdue: true,
            }
          }
          this.workDetail = workDetailData
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  updateStatusWork = (work_code, status) => {
    return new Promise((resolve, reject) => {
      WorkRequest.updateStatusWork(work_code, status)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  setWorkList = newList => {
    this.workList = newList
  }

  deleteWork = work_code => {
    return new Promise((resolve, reject) => {
      WorkRequest.deleteWork(work_code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  updateWork = (work_code, data) => {
    return new Promise((resolve, reject) => {
      WorkRequest.updateWork(work_code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  updatePeopleInvole = (work_code, data) => {
    return new Promise((resolve, reject) => {
      WorkRequest.updatePeopleInvole(work_code, data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  getCommentWorkList = work_code => {
    return new Promise((resolve, reject) => {
      WorkRequest.getCommentWorkList(work_code)
        .then(response => {
          this.commentWorkList = response.data.reverse()
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createCommentWork = (work_code, data) => {
    return new Promise((resolve, reject) => {
      WorkRequest.createCommentWork(work_code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  deleteCommentWork = (work_code, id_comment) => {
    return new Promise((resolve, reject) => {
      WorkRequest.deleteCommentWork(work_code, id_comment)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  clearWorkDetail = () => {
    this.workDetail = {}
  }
  clearSubWork = () => {
    this.subwork = []
  }

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  clearWorkStore = () => {
    this.workList.length = 0
    this.totalWork = 0
    this.workDetail = {}
    this.commentWorkList = undefined
    this.workCompleteCount = 0
    this.workPendingCount = 0
    this.groupVanThu = null
    this.defaultQueryParams = {
      page: 0,
      size: 10,
      title: null,
      from_date: null,
      to_date: null,
      status: undefined,
      work_type: null,
      permission: undefined,
      parent_id: null,
      is_important: null,
      is_unread: null,
      assignee: null,
    }
  }

  clearWorkList = () => {
    this.workList.length = 0
    this.totalWork = 0
  }

  getGroupVanThu = async () => {
    let response = await UserGroupRequest.getGroupVanThu()
    this.groupVanThu = response.data
  }
}
const workStore = new WorkStore()
export default workStore
